import React from "react";

function Balance() {
  return (
    <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.7 7.89998V15.5H26.7V7.89998C26.7 7.35998 26.22 7.09998 25.9 7.09998C25.8 7.09998 25.7 7.11998 25.6 7.15998L9.74 13.14C8.68 13.54 8 14.54 8 15.68V17.02C6.18 18.38 5 20.56 5 23.02V15.68C5 13.3 6.46 11.18 8.68 10.34L24.56 4.33998C25 4.17998 25.46 4.09998 25.9 4.09998C27.9 4.09998 29.7 5.71998 29.7 7.89998ZM43 29V31C43.0001 31.2618 42.8974 31.5131 42.7142 31.7001C42.531 31.8871 42.2817 31.9947 42.02 32H39.1C38.04 32 37.08 31.22 37 30.18C36.94 29.56 37.18 28.98 37.58 28.58C37.7611 28.3924 37.9788 28.2441 38.2197 28.1444C38.4605 28.0446 38.7193 27.9954 38.98 28H42C42.58 28.02 43 28.46 43 29Z"
        fill="#DD7BFF"
      />
      <path
        d="M38.96 25.9H41C42.1 25.9 43 25 43 23.9V23.02C43 18.88 39.62 15.5 35.48 15.5H12.52C10.82 15.5 9.26 16.06 8 17.02C6.18 18.38 5 20.56 5 23.02V36.48C5 40.62 8.38 44 12.52 44H35.48C39.62 44 43 40.62 43 36.48V36.1C43 35 42.1 34.1 41 34.1H39.26C37.34 34.1 35.5 32.92 35 31.06C34.58 29.54 35.08 28.08 36.08 27.1C36.82 26.34 37.84 25.9 38.96 25.9ZM28 25.5H14C13.18 25.5 12.5 24.82 12.5 24C12.5 23.18 13.18 22.5 14 22.5H28C28.82 22.5 29.5 23.18 29.5 24C29.5 24.82 28.82 25.5 28 25.5Z"
        fill="#DD7BFF"
      />
    </svg>
  );
}

export default Balance;
